__turbopack_context__.v({
  "heading-container": "Ddct-G_heading-container",
  "product-item": "Ddct-G_product-item",
  "products-list": "Ddct-G_products-list",
  "recently-viewed-products": "Ddct-G_recently-viewed-products",
  "title": "Ddct-G_title",
});
